import { ProgressLoaderService } from 'src/app/core/core';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';

import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
    selector: 'pgh-loader-progress',
    templateUrl: './loader-progress.component.html',
    styleUrls: ['./loader-progress.component.css'],
    imports: [MatProgressBar]
})
export class LoaderProgressComponent implements OnInit, OnDestroy {
  show = false;
  private subscription: Subscription;
  constructor(private loaderService: ProgressLoaderService) {}
  ngOnInit() {
    this.subscription = this.loaderService.loaderState.subscribe(value => {
      this.show = value.show;
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
